'use client';
import React from 'react'
import { ButtonSize, ButtonVariant, RegularButton } from '@/stories/button/button';
import { setAnalyticsEvent } from '@/app/utils/SetAnalyticsEvent';
import { useRouter } from 'next/navigation';
import { buildKycRedirectUrl } from '@/app/utils/kyc-routing';

const StartKycCompTemp = () => {
    const router = useRouter();

    return (
        <div className="min-h-[333px] w-full flex flex-col items-center justify-center">
            <p className="text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-center mb-[47px]">
                Complete your KYC to be eligible to Refer
            </p>
            <RegularButton
                noIcon
                showRightIcon={false}
                size={ButtonSize.Large}
                variant={ButtonVariant.PrimaryDefault}
                className="max-w-1/2 w-full sm:w-3/5 md:max-w-fit"
                label="Start KYC"
                onClick={() => {
                    setAnalyticsEvent(`${process.env.ICM_URL}/refer`, "US_Listing_Page_Refer_Friend_Fold 8");
                    router.push(buildKycRedirectUrl({ redirectUrl: '/refer' }))
                }}
            />
        </div>
    );
};

export default StartKycCompTemp